/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Textbox from '../Textbox/Textbox';
import Label from '../Label/Label';
import Button from '../Button/Button';
import Spinner from '../Spinner/Spinner';
import Dialog from '../Dialog/Dialog';
import Firebase from '../Util/Firebase';
import Service from '../Util/Service';
import $ from '../Util/Util';
import Logo from './logo.png';
import './Login.css';

/**
 * Represents the login screen.
 */

export default class Login extends Component {
   
    /**
     * Properties.
     */

    static propTypes = {
        context:            PropTypes.object.isRequired,
        onLogin:            PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

    state = {
        inprogress:         false,
        message:            { title: null, content: null }
    }

    /** 
     * Event that fires when the component mounted.
     */

    componentDidMount() {

        // Getting production or test mode

        let testMode = $.getURLParameters().test;

        // Initializing the Fireabase

        Firebase.startup(
            testMode ? 'AIzaSyA_DQuzxjjgbH_fYl8m6CqMjdUV1gt9C4o' : 'AIzaSyCwM8ncPM19RysTE57PfGrWYNuGpGPvtSQ',
            testMode ? 'minicrs-test' : 'minicrs-1b7e2'
        ).then((user) => {

            // Logs out the user if she/he is in logged in state

            if (user) {
                Firebase.logout();
            }
            
            if (window.location.hostname === 'localhost') {
                this.email.setValue('andras.sarvari@sarvaria.net');
                this.password.setValue('minicrs');
            }
        }).catch((error) => {

            // Reloading the page in case failed

            window.location.reload();
        });                
    }

    /**
     * Sends a password change email.
     */

    _forgotPassword = () => {

        // Does the email address specified and does it valid?

        if (this.email.isEmpty() || !$.isEmailValid(this.email.getValue())) {
            this.email.setError(this.props.context.locale.login.invalidemail);
            this.password.setValue('');
        } else {

            // Sending password change email

            Firebase.forgotPassword(this.email.getValue(), this.props.context.locale.locale).then(() => {

                // Email sent successfully. Showing confirm message.

                this.setState({ message: { 
                    title:      this.props.context.locale.login.changepassword.title,
                    content:    this.props.context.locale.login.changepassword.message.success
                }}, () => {
                    this.message.open();
                });                
            }).catch((error) => {

                // Sending of the email failed. Showing failed message.

                this.setState({ message: {
                    title:      this.props.context.locale.login.changepassword.title,                    
                    content:    this.props.context.locale.login.changepassword.message.failed
                }}, () => {
                    this.message.open();
                });
            });
        }
    }

    /**
     * Tries to log in to the system.
     */

    _login = () => {

        // Login failed

        let failed = () => {
            this.setState({inprogress : false}, () => {
                this.email.setError(this.props.context.locale.login.loginfailed);
                this.password.setValue('');
            });
        };

        // Does the email address and the password specified and does the
        // email address valid?

        if (this.email.isEmpty() || this.password.isEmpty() || !$.isEmailValid(this.email.getValue())) {

            // Login failed

            failed();
        } else {

            // Login against the email and password

            this.setState({inprogress : true}, () => {
                Firebase.login(Firebase.PROVIDER.EMAILPASSWORD, this.email.getValue(), this.password.getValue()).then((user) => {

                    // Login information is valid

                    if (user) {

                        // Getting the user information

                        Service.loadUser(user.uid).then((user) => {

                            // Does the user exists?

                            if (user) {

                                // Loading the groups

                                Service.loadGroup().then((groups) => {

                                // Getting the group information

                                    for (let i = 0; i < groups.length; i++) {
                                        if (groups[i].members && groups[i].members.indexOf(user.uid)) {
                                            user.group = groups[i];
                                            break;
                                        }
                                    }

                                    // Refreshing last login information
                                    
                                    Service.refreshLastLogin(user.uid).then(() => {

                                        // Storing the password as well for later administration usage
                                        
                                        user.password = this.password.getValue();

                                        this.setState({inprogress : false}, () => {

                                            // Login was success
                                            
                                            this.email.setValue('');
                                            this.password.setValue('');
                                            this.props.onLogin(user);
                                        });
                                    }).catch((error) => {

                                        // Login failed
                        
                                        failed();
                                    });
                                }).catch((error) => {

                                    // Login failed
                    
                                    failed();
                                });
                            } else {

                                // Login failed
                
                                failed();
                            }
                        }).catch((error) => {

                            // Login failed
            
                            failed();
                        });
                    } else {

                        // Login failed

                        failed();
                    }
                }).catch((error) => {
    
                    // Login failed
    
                    failed();
                });    
            });
        }
    }

    /**
     * Sets the focus to the password field.
     */

    _focusToPassword = () => {

        // Setting the focus to the password field

        this.password.setFocus();
    }

    /**
     * Event that fires when the user touches the "Ok" button on the dialog.
     */

    _closeMessage = () => {

        // Closing the dialog

        this.message.close();
    }

    /**
     * Logs the current user out.
     * 
     * @return  {Object}    promise         promise object
     */

    logout = () => {

        // Creating and returning the promise object

        return new Promise((resolve, reject) => {

            // Callback function

            let callback = () => {
                this.setState({inprogress : false}, () => {
                    resolve();
                });
            };

            // Logging out
            
            this.setState({inprogress : true}, () => {
                Firebase.logout().then(() => {
                    callback();
                }).catch((error) => {
                    callback();
                });
            });
        });
    }

    /**
     * Login screen renderer.
     */

    render() {
        return (
            <div className="login vertical horizontal center center-justified">
            
                { /* Mobile environment */ this.props.context.environment.browser.info.mobile ?

                <div className="vertical center">

                    {/* Name of the application */}

                    <div className="login-appname login-appname-mobile">{this.props.context.locale.login.applicationname}</div>
                    
                    {/* Logo */}
                    
                    <img alt="Logo" src={Logo} className="login-logo login-logo-mobile" />

                    <div>

                        {/* Email */}

                        <Textbox ref={c => {this.email = c;}} label={`${this.props.context.locale.login.email}:`} maxlength={100} labelwidth={60} width={200} onEnter={this._focusToPassword} />

                        {/* Password */}

                        <Textbox ref={c => {this.password = c;}} label={`${this.props.context.locale.login.password}:`} maxlength={100} password labelwidth={60} width={200} onEnter={this._login} />

                        {/* Forgot password */}

                        <div className="login-forgotpassword horizontal">
                            <div className="flex"></div>
                            <Label text={this.props.context.locale.login.forgotpassword.label} tooltip={this.props.context.locale.login.forgotpassword.tooltip} link onTouch={this._forgotPassword} />
                        </div>

                        {/* Login button */}

                        <div className="horizontal center-justified">
                            <Button label={this.props.context.locale.login.button.label} topgap={32} width={100} onTouch={this._login}/>
                        </div>
                    </div>
                </div>

                /* Desktop environment */ : 

                <div className="vertical center">

                    {/* Name of the application */}

                    <div className="login-appname login-appname-desktop">{this.props.context.locale.login.applicationname}</div>

                    <div className="horizontal">

                        {/* Logo */}
        
                        <img alt="Logo" src={Logo} className="login-logo login-logo-desktop" />
        
                        <div>

                            {/* Email */}

                            <Textbox ref={c => {this.email = c;}} label={`${this.props.context.locale.login.email}:`} maxlength={100} labelwidth={60} width={200} onEnter={this._focusToPassword} />
        
                            {/* Password */}

                            <Textbox ref={c => {this.password = c;}} label={`${this.props.context.locale.login.password}:`} maxlength={100} password labelwidth={60} width={200} onEnter={this._login} />

                            {/* Forgot password */}

                            <div className="login-forgotpassword horizontal">
                                <div className="flex"></div>
                                <Label text={this.props.context.locale.login.forgotpassword.label} tooltip={this.props.context.locale.login.forgotpassword.tooltip} link onTouch={this._forgotPassword} />
                            </div>

                            {/* Login button */}
                            
                            <Button label={this.props.context.locale.login.button.label} tooltip={this.props.context.locale.login.button.tooltip} topgap={16} leftgap={60} width={100} onTouch={this._login}/>
                        </div>
                    </div>
                </div>}

                {/* Spinner */}

                { this.state.inprogress && <Spinner modal color={Spinner.COLOR.WHITE} /> }

                {/* Message dialog */}

                <Dialog ref={c => {this.message = c;}} width={260} height={132} hideclosebutton>
                    <div className="login-message-title">{this.state.message.title}</div>
                    <div className="login-message">{this.state.message.content}</div>
                    <div className="horizontal center-justified">
                        <Button label={this.props.context.locale.login.messagedialog.button.label} tooltip={this.props.context.locale.login.messagedialog.button.label} topgap={24} onTouch={this._closeMessage}/>
                    </div>
                </Dialog>

                {/* Copyright information */}

                <div className="login-copyright">{this.props.context.locale.login.copyright}{this.props.context.version}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.js